import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AddTagFn } from '@ng-select/ng-select/lib/ng-select.component';
import { Subject, takeUntil } from 'rxjs';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { ValueListService } from 'src/app/Common/ValueListService/value-list.service';
import { ValueListDTO } from 'src/app/Common/ValueListService/valuelist.interface';
import { ValueListItemCreateRequestDTO, ValueListItemDTO } from 'src/app/Common/ValueListService/ValueListItem.interface';

@Component({
  selector: 'app-valuelist-selector',
  templateUrl: './valuelist-selector.component.html',
  styleUrls: ['./valuelist-selector.component.css']
})
export class
  ValuelistSelectorComponent implements OnInit, OnDestroy {

isLoading: boolean = false;

  @Input({ required: true }) control!: FormControl;
  @Input({ required: true }) vlCode!: string;
  @Input() placeholder: string = 'Select an option';
  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>();
  @Output() onChange: EventEmitter<ValueListItemDTO> = new EventEmitter<ValueListItemDTO>();
  @Output() tagAdded = new EventEmitter<string>();
  @Input() allowAddingItem:boolean = false
  User = inject(UserLoginService).User()
  addTag: AddTagFn = (name: string) => {
    if(this.valueList && this.valueList.valueListId > 0){
      let data: ValueListItemCreateRequestDTO = {
        valueListId: this.valueList.valueListId,
        tenantId: this.User.companyId,
        tenantBranchId: this.User.loggedInBranchId,
        vliCode: name,
        vliName: name,
        vliDesc: name,
        displaySeq: 0,
        addField1: '',
        addField2: '',
        addField3: '',
        actionUser: this.User.userId.toString()
      }
      this.isLoading = true
      this.valueListService.ValueListItem_create(data).subscribe(res => {
        this.tagAdded.emit(name)
        this.control.patchValue(name.trim())
        this.isLoading = false

      })
    }
  };

  valueListItems: ValueListItemDTO[] = [];
  valueList: ValueListDTO | undefined = undefined

  constructor(private valueListService: ValueListService) { }

  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    if (this.vlCode) {
      this.loadValueListItems();
    }
  }

  ngOnChanges() {
    if (this.vlCode) {
      this.loadValueListItems();
    }
  }

  private loadValueListItems() {
    this.valueListService.getItemByVLCode(this.vlCode).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.valueListItems = res.valueListItems;
      console.log(this.valueListItems);
      
      this.valueList = res.ValueList
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}